import React from "react";
import Personaldetails from "Pages/Personaldetails";


const Personaldetailtheme = () => {
  return (
    <React.Fragment>
       <Personaldetails/>
    </React.Fragment>
  );
};

export default Personaldetailtheme;
